/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrGammaGTsTypename = "PhrGammaGTs" as const;

/**
 *
 * @export
 * @interface PhrGammaGTs
 */
export interface PhrGammaGTs {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGammaGTs
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGammaGTs
   */
  violetAbsorptionSpectrophotometry?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrGammaGTs
   */
  readonly __typename?: string;
}

export function PhrGammaGTsFromJSON(json: any): PhrGammaGTs {
  return PhrGammaGTsFromJSONTyped(json, false);
}

export function PhrGammaGTsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrGammaGTs {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrGammaGTsTypename,

    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    violetAbsorptionSpectrophotometry: !exists(json, "violet_absorption_spectrophotometry")
      ? undefined
      : PhrMeasurementFromJSON(json["violet_absorption_spectrophotometry"]),
  };
}

export function PhrGammaGTsToJSON(object?: PhrGammaGTs | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    other: PhrMeasurementToJSON(value.other),
    violet_absorption_spectrophotometry: PhrMeasurementToJSON(value.violetAbsorptionSpectrophotometry),
  };
}
